/* eslint-disable jira/filename-case */
import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const pageLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageLoad,
	}),
);

export const globalFieldCreate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-create', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const globalFieldDelete: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-delete', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const globalFieldAssociate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-associate', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const globalFieldUnassociate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-unassociate', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const globalFieldCheckViewsUsage: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-check-views-usage', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldUpdate: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-update', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const globalFieldUpdateConfig: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-update-config', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const globalFieldCheckProjectUsage: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.global-fields-administration.field-check-project-usage', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const loadGlobalFields: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.load-fields', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadGlobalLabels: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.load-global-labels', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadJpdProjects: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.load-jpd-projects', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadProjectsWithField: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.load-projects-with-field', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const fieldAddOptions: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-add-options', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const fieldDeleteOption: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-delete-option', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const fieldRenameOption: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-rename-option', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const fieldMoveOptions: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.field-move-options', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const copyValues: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.global-fields-administration.copy-values', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);
